const React = require('react')
const { useHistory } = require('react-router-dom')
const { Table } = require('reactstrap')
const { useNetworkConfig } = require('@contexts')
const { LoadingSpinner } = require('@components')
const { useFormatBytes, useResponsive, BREAKPOINTS } = require('@hooks')

require('@styles/pages/transaction/states.transaction.css')

const TransactionStates = props => {
    const { loading, data } = props
    const history = useHistory()
    const { network } = useNetworkConfig()
    const formatBytes = useFormatBytes()
    const isMobile = useResponsive(BREAKPOINTS.large)

    return (
        <div className='box table-section'>
            {loading ? (
                <div className='d-flex justify-content-center align-items-center' style={{ height: '300px' }}>
                    <LoadingSpinner />
                </div>
            ) : (
                <>
                    <span style={{ marginBottom: '16px', display: 'block', color: 'var(--white-color)' }}>
                        <span className='status-box pending'>Advanced</span>
                        &nbsp;A set of information that represents the current&nbsp;
                        <span style={{ fontWeight: 'bold' }}>state</span>&nbsp;is updated when a transaction takes place
                        on the network. The below is a summary of those changes :
                    </span>

                    <Table
                        responsive
                        className='transaction-sub-table mb-0'
                        style={isMobile ? { display: 'block', overflowX: 'auto', whiteSpace: 'nowrap' } : {}}
                    >
                        <thead>
                            <tr>
                                <th>Address</th>
                                <th />
                                <th style={{ textAlign: 'center' }}>Before</th>
                                <th style={{ textAlign: 'center' }}>After</th>
                                <th style={{ textAlign: 'center' }}>State Difference</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data?.states.map((state, index) => (
                                <tr key={index}>
                                    <td>
                                        <div className='d-flex align-items-center'>
                                            <span
                                                className={`${network.name}-text-color cursor-pointer`}
                                                onClick={() =>
                                                    history.push(`/${network.name}/address/${state.address}`)
                                                }
                                            >
                                                {formatBytes(state.address, 50, 42, 0)}
                                            </span>
                                        </div>
                                    </td>
                                    <td>{state.tokenSymbol}</td>
                                    <td style={{ textAlign: 'center' }}>
                                        {(state.balanceBefore / 10 ** state.tokenDecimals).toLocaleString(undefined, {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: state.tokenDecimals
                                        })}
                                    </td>
                                    <td style={{ textAlign: 'center' }}>
                                        {(state.balanceAfter / 10 ** state.tokenDecimals).toLocaleString(undefined, {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: state.tokenDecimals
                                        })}
                                    </td>
                                    <td style={{ textAlign: 'center' }}>
                                        {(
                                            (state.balanceAfter - state.balanceBefore) /
                                            10 ** state.tokenDecimals
                                        ).toLocaleString(undefined, {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: state.tokenDecimals
                                        })}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </>
            )}
        </div>
    )
}

module.exports = { TransactionStates }
